<template>
  <div v-hotkey="keymap">
    <slot :preselected="preselectedIndex"></slot>
  </div>
</template>

<script>
  export default {
    props: ['keyLevel', 'size', 'defaultIndex'],

    data() {
      return {
        preselectedIndex: -1
      }
    },

    mounted() {
      this.preselectedIndex = this.defaultIndex !== undefined ? this.defaultIndex : -1
    },

    watch: {
      defaultIndex() {
        this.preselectedIndex = this.defaultIndex
      },

      preselectedIndex() {
        if (this.preselectedIndex !== -1) {
          this.$emit('preselected', this.preselectedIndex);
        }
      }
    },

    methods: {
      back() {
        const escapeIndex = this.defaultIndex !== undefined ? this.defaultIndex : -1;

        if (this.preselectedIndex !== escapeIndex) {
          this.preselectedIndex = escapeIndex
        } else {
          this.$emit('deselected');
        }
      },

      enter() {
        if (this.preselectedIndex !== -1) {
          this.$emit('selected', this.preselectedIndex);
        }
      },
      
      right() {
        if (this.preselectedIndex >= this.size - 1) {
          this.preselectedIndex = -1
        } else {
          this.preselectedIndex++
        }
      },

      left() {
        if (this.preselectedIndex < 0) {
          this.preselectedIndex = this.size - 1
        } else {
          this.preselectedIndex--
        }
      }
    },

    computed: {
      keymap() {
        return this.keystopper(this.keyLevel, {
          'escape': this.back,
          'enter': this.enter,

          'left': this.left,
          'right': this.right
        }, {})
      }
    }
  }
</script>